import FormPoster from "@/js/libs/formPoster";
import summary from "@/js/parts/checkout/refreshSummary";
import { InputErrors } from "@/js/libs/form-errors";
import isInCart from "@/js/libs/isInCart";

export default function (form) {
  // Update Line Items - look at every form in a page with this
  // data attribute and individually listen for input changes,
  // to send a fresh update. Will update the line items...so this
  // expects a form PER line item.

  const Form = new FormPoster({
    form: form,
  });

  if (!Form.ready) {
    return;
  }

  const productInput = form.querySelector("[data-product-id]");
  console.log(productInput);
  const qtySelect = form.querySelector("[data-qty-select]");
  const productPurchasableId = productInput
    ? productInput.dataset.productId
    : null;

  /*
		Update this particular form's line item hidden fields,
		changing it from an 'add to cart' form, to a 'update line item'
		form and back again as necessary, based on whether there is 0 or
		more. Means the select thus behaves as a simple select 0-9 no matter
		the initial or continuing state.

		if productPurchasableId AKA data-product-id is not found then this
		script should just act as a simple repeating update to whatever
		the original action was. If it _IS_ found then expect the action
		to get manipulated.
	*/

  const qtyHandler = function (input) {
    this.originalValue = input.getAttribute("value");
    this.errors = new InputErrors(input);
    this.input = input;

    input.addEventListener("change", () => {
      // Ensure the latest values are scraped for this form:
      Form.updateFormValues();

      const newValue = input.value;

      this.errors.clear();

      // if you want to see what is about to be posted:
      // Form.logValues();

      // Set a visual loading state:
      Form.states.loading();
      summary.loading();

      // Post the form:
      Form.post((response) => {
        // Update the line items
        if (response.success) {
          this.updateForm(response.cart, newValue);
        } else if (response.error) {
          console.log(response.error);
          this.handleError(response.error, this.originalValue);
        }

        // Get a new summary:
        summary.refresh(() => {
          Form.states.ready();
        });
      });
    });

    // trigger a change so that we instantly post
    // this is the easiest way to add "syncQty" add-ons to the dining cart
    if(Form.form.hasAttribute('data-sync-qty')) {
      //input.dispatchEvent(new Event("change"));
    }
  };

  qtyHandler.prototype.handleError = function (errorMsg, revertValue) {
    this.input.value = revertValue;
    this.errors.replace(errorMsg);
  };

  qtyHandler.prototype.updateForm = function (cart, newValue) {
    if (!productPurchasableId || !productInput) {
      return;
    }

    const item = isInCart(cart, productPurchasableId);

    if (item) {
      const actualValue = parseInt(item.qty);

      if (newValue > actualValue) {
        this.handleError(
          `Only ${actualValue} were available and added to your order`,
          actualValue,
        );

        this.originalValue = actualValue;
      } else {
        this.originalValue = newValue;
      }

      // line item updates only need a qty field with the lineItem id
      productInput.setAttribute("disabled", "disabled");
      qtySelect.setAttribute("name", "lineItems[" + item.id + "][qty]");
    } else {
      this.originalValue = 0;

      // new items need a purchaseableId (product's defaultVariant) and qty
      productInput.setAttribute("name", "purchasableId");
      productInput.removeAttribute("disabled");
      productInput.setAttribute("value", productPurchasableId);
      qtySelect.setAttribute("name", "qty");
    }
  };

  // Only listen to one select in the form. Because otherwise it's going to get confusing
  // when multiple control things.
  var changeQty = form.querySelector("[data-qty-select]");
  new qtyHandler(changeQty);
}
